import {
  USAGE_EXPLORER_FEATURE_FLAGS,
  USAGE_EXPLORER_GET_USAGE_CURATION,
  USAGE_EXPLORER_GET_USAGE_JAS,
  USAGE_EXPLORER_GET_USAGE_ML_CACHE,
  USAGE_EXPLORER_GET_USAGE_ML_CREDITS,
  USAGE_EXPLORER_GET_USAGE_PROJECTS,
  USAGE_EXPLORER_GET_USAGE_STORAGE,
  USAGE_EXPLORER_GET_USAGE_TRAFFIC,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import usageExplorerGetUsageStorage from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageStorage.ts";
import usageExplorerGetUsageTraffic from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageTraffic.ts";
import usageExplorerGetUsageProjects from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageProjects.ts";
import usageExplorerGetUsageJas from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageJas.ts";
import usageExplorerGetUsageCuration from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageCuration.ts";
import usageExplorerGetUsageMlCredits from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageMlCredits.ts";
import usageExplorerGetUsageMlCache from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerGetUsageMlCache.ts";
import usageExplorerFeatureFlags from "@shared/services/tour/mockedApis/usageExplorer/usageExplorerFeatureFlags.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";

export default {
  [USAGE_EXPLORER_GET_USAGE_TRAFFIC]: (data?: object) =>
    usageExplorerGetUsageTraffic(data),
  [USAGE_EXPLORER_GET_USAGE_STORAGE]: (data?: object) =>
    usageExplorerGetUsageStorage(data),
  [USAGE_EXPLORER_GET_USAGE_PROJECTS]: (data?: object) =>
    usageExplorerGetUsageProjects(data),
  [USAGE_EXPLORER_GET_USAGE_JAS]: (data?: object) =>
    usageExplorerGetUsageJas(data),
  [USAGE_EXPLORER_GET_USAGE_CURATION]: (data?: object) =>
    usageExplorerGetUsageCuration(data),
  [USAGE_EXPLORER_GET_USAGE_ML_CREDITS]: (data?: object) =>
    usageExplorerGetUsageMlCredits(data),
  [USAGE_EXPLORER_GET_USAGE_ML_CACHE]: (data?: object) =>
    usageExplorerGetUsageMlCache(data),
  [USAGE_EXPLORER_FEATURE_FLAGS]: () => usageExplorerFeatureFlags(),
} satisfies TourUrlMapping;
